import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { featureArticleHref } from '../../lib/featureArticles';
import { prefetchArticleBySlug } from '../../lib/publicContentCache';
import type { ArticleRow } from '../../../../shared/schemas/article';

interface RecentFeaturesSidebarProps {
  entries: ArticleRow[];
  currentSlug: string;
}

export function RecentFeaturesSidebar({ entries, currentSlug }: RecentFeaturesSidebarProps) {
  const others = entries.filter((entry) => entry.slug !== currentSlug);

  return (
    <aside className="flex w-article-sidebar flex-col gap-6">
      <p className="text-caption-lg text-text-tertiary">Latest Features</p>

      {others.map((entry) => (
        <a
          key={entry.slug}
          href={featureArticleHref(entry.slug)}
          className="text-btn leading-normal text-text-primary transition-colors hover:text-text-secondary"
          onMouseEnter={() => prefetchArticleBySlug(entry.slug)}
          onFocus={() => prefetchArticleBySlug(entry.slug)}
        >
          {entry.title}
        </a>
      ))}

      <a href="/features" className="site-btn-secondary site-btn-md">
        All features
        <ArrowUpRight size={14} />
      </a>
    </aside>
  );
}
